const OPTIONS = [
	"Afrikaans",
	"Albanian",
	"Arabic",
	"Azerbaijani",
	"Bengali",
	"Bulgarian",
	"Catalan",
	"Chinese (CHN)",
	"Chinese (HKG)",
	"Chinese (TAI)",
	"Croatian",
	"Czech",
	"Danish",
	"Dutch",
	"English",
	"English (UK)",
	"English (US)",
	"Estonian",
	"Filipino",
	"Finnish",
	"French",
	"German",
	"Greek",
	"Gujarati",
	"Hausa",
	"Hebrew",
	"Hindi",
	"Hungarian",
	"Indonesian",
	"Irish",
	"Italian",
	"Japanese",
	"Kannada",
	"Kazakh",
	"Korean",
	"Lao",
	"Latvian",
	"Lithuanian",
	"Macedonian",
	"Malay",
	"Malayalam",
	"Marathi",
	"Norwegian",
	"Persian",
	"Polish",
	"Portuguese (BR)",
	"Portuguese (POR)",
	"Punjabi",
	"Romanian",
	"Russian",
	"Serbian",
	"Slovak",
	"Slovenian",
	"Spanish",
	"Spanish (ARG)",
	"Spanish (SPA)",
	"Spanish (MEX)",
	"Swahili",
	"Swedish",
	"Tamil",
	"Telugu",
	"Thai",
	"Turkish",
	"Ukrainian",
	"Urdu",
	"Uzbek",
	"Vietnamese",
	"Zulu"
]

export const AUTH_LANGUAGES = {
	Afrikaans: {
		templateFormat: "*{{1}}* is jou verifikasiekode.",
		codeExpirationWarning: "Hierdie kode verval oor <> minute.",
		securityText: "Vir jou veiligheid, moenie hierdie kode deel nie.",
		copyCode: "Kopieer kode",
	},
	Albanian: {
		templateFormat: "*{{1}}* është kodi juaj i verifikimit.",
		codeExpirationWarning: "Ky kod skadon për <> minutë.",
		securityText: "Për sigurinë tuaj, mos ndani këtë kod.",
		copyCode: "Kopjo kodin",
	},
	Arabic: {
		templateFormat: "*{{1}}* هو رمز التحقق الخاص بك.",
		codeExpirationWarning: "ستنتهي صلاحية هذا الرمز في غضون <> دقيقة.",
		securityText: "لأمانك، لا تشارك هذا الرمز.",
		copyCode: "نسخ الرمز",
	},
	Azerbaijani: {
		templateFormat: "*{{1}}* sizin doğrulama kodunuzdur.",
		codeExpirationWarning: "Bu kod <> dəqiqə ərzində müddəti bitəcək.",
		securityText: "Təhlükəsizliyiniz üçün bu kodu paylaşmayın.",
		copyCode: "Kodu kopyalayın",
	},
	Bengali: {
		templateFormat: "*{{1}}* আপনার যাচাইকরণ কোড।",
		codeExpirationWarning: "এই কোডটি <> মিনিটের মধ্যে মেয়াদ শেষ হয়ে যাবে।",
		securityText: "আপনার নিরাপত্তার জন্য, এই কোডটি শেয়ার করবেন না।",
		copyCode: "কোড কপি করুন",
	},
	Bulgarian: {
		templateFormat: "*{{1}}* е вашият код за потвърждение.",
		codeExpirationWarning: "Този код изтича след <> минути.",
		securityText: "За вашата сигурност, не споделяйте този код.",
		copyCode: "Копиране на кода",
	},
	Catalan: {
		templateFormat: "*{{1}}* és el teu codi de verificació.",
		codeExpirationWarning: "Aquest codi caduca en <> minuts.",
		securityText: "Per a la teva seguretat, no comparteixis aquest codi.",
		copyCode: "Copia el codi",
	},
	"Chinese (CHN)": {
		templateFormat: "*{{1}}* 是您的验证码。",
		codeExpirationWarning: "此验证码将在<>分钟内过期。",
		securityText: "为了您的安全，请勿分享此验证码。",
		copyCode: "复制代码",
	},
	"Chinese (HKG)": {
		templateFormat: "*{{1}}* 是您的驗證碼。",
		codeExpirationWarning: "此驗證碼將在<>分鐘內過期。",
		securityText: "為了您的安全，請勿分享此驗證碼。",
		copyCode: "複製代碼",
	},
	"Chinese (TAI)": {
		templateFormat: "*{{1}}* 是您的驗證碼。",
		codeExpirationWarning: "此驗證碼將在<>分鐘內過期。",
		securityText: "為了您的安全，請勿分享此驗證碼。",
		copyCode: "複製代碼",
	},
	Croatian: {
		templateFormat: "*{{1}}* je vaš verifikacijski kod.",
		codeExpirationWarning: "Ovaj kod ističe za <> minuta.",
		securityText: "Za vašu sigurnost, nemojte dijeliti ovaj kod.",
		copyCode: "Kopiraj kod",
	},
	Czech: {
		templateFormat: "*{{1}}* je váš ověřovací kód.",
		codeExpirationWarning: "Tento kód vyprší za <> minut.",
		securityText: "Pro vaši bezpečnost tento kód nesdílejte.",
		copyCode: "Kopírovat kód",
	},
	Danish: {
		templateFormat: "*{{1}}* er din bekræftelseskode.",
		codeExpirationWarning: "Denne kode udløber om <> minutter.",
		securityText: "Af hensyn til din sikkerhed skal du ikke dele denne kode.",
		copyCode: "Kopier kode",
	},
	Dutch: {
		templateFormat: "*{{1}}* is uw verificatiecode.",
		codeExpirationWarning: "Deze code verloopt over <> minuten.",
		securityText: "Voor uw veiligheid, deel deze code niet.",
		copyCode: "Kopieer code",
	},
	English: {
		templateFormat: "*{{1}}* is your verification code.",
		codeExpirationWarning: "This code expires in <> minute(s).",
		securityText: "For your security, do not share this code.",
		copyCode: "Copy code",
	},
	"English (UK)": {
		templateFormat: "*{{1}}* is your verification code.",
		codeExpirationWarning: "This code expires in <> minute(s).",
		securityText: "For your security, do not share this code.",
		copyCode: "Copy code",
	},
	"English (US)": {
		templateFormat: "*{{1}}* is your verification code.",
		codeExpirationWarning: "This code expires in <> minute(s).",
		securityText: "For your security, do not share this code.",
		copyCode: "Copy code",
	},
	Estonian: {
		templateFormat: "*{{1}}* on teie kinnituskood.",
		codeExpirationWarning: "See kood aegub <> minuti pärast.",
		securityText: "Teie turvalisuse huvides ärge jagage seda koodi.",
		copyCode: "Kopeeri kood",
	},
	Filipino: {
		templateFormat: "*{{1}}* ang iyong verification code.",
		codeExpirationWarning:
			"Mawawalang bisa ang code na ito sa loob ng <> minuto.",
		securityText: "Para sa iyong seguridad, huwag ibahagi ang code na ito.",
		copyCode: "Kopyahin ang code",
	},
	Finnish: {
		templateFormat: "*{{1}}* on vahvistuskoodisi.",
		codeExpirationWarning: "Tämä koodi vanhenee <> minuutissa.",
		securityText: "Turvallisuutesi vuoksi älä jaa tätä koodia.",
		copyCode: "Kopioi koodi",
	},
	French: {
		templateFormat: "*{{1}}* est votre code de vérification.",
		codeExpirationWarning: "Ce code expire dans <> minute(s).",
		securityText: "Pour votre sécurité, ne partagez pas ce code.",
		copyCode: "Copier le code",
	},
	German: {
		templateFormat: "*{{1}}* ist Ihr Bestätigungscode.",
		codeExpirationWarning: "Dieser Code läuft in <> Minute(n) ab.",
		securityText: "Zu Ihrer Sicherheit teilen Sie diesen Code nicht.",
		copyCode: "Code kopieren",
	},
	Greek: {
		templateFormat: "*{{1}}* είναι ο κωδικός επαλήθευσης σας.",
		codeExpirationWarning: "Αυτός ο κωδικός λήγει σε <> λεπτά.",
		securityText: "Για την ασφάλειά σας, μην μοιράζεστε αυτόν τον κωδικό.",
		copyCode: "Αντιγραφή κωδικού",
	},
	Gujarati: {
		templateFormat: "*{{1}}* તમારો ચકાસણી કોડ છે.",
		codeExpirationWarning: "આ કોડ <> મિનિટમાં સમય મર્યાદિત થઈ જશે.",
		securityText: "તમારી સુરક્ષાની દ્રષ્ટિએ, આ કોડ શેર ન કરો.",
		copyCode: "કોડ કૉપિ કરો",
	},
	Hausa: {
		templateFormat: "*{{1}}* shine lambar tabbatarwa.",
		codeExpirationWarning: "Wannan lambar ta ƙare a cikin minti <>.",
		securityText: "Don tsaron ku, kar ku raba wannan lambar.",
		copyCode: "Kwafi lambar",
	},
	Hebrew: {
		templateFormat: "*{{1}}* הוא קוד האימות שלך.",
		codeExpirationWarning: "קוד זה יפוג בעוד <> דקות.",
		securityText: "למען ביטחונך, אל תשתף קוד זה.",
		copyCode: "העתק קוד",
	},
	Hindi: {
		templateFormat: "*{{1}}* आपका वेरिफ़िकेशन कोड है.",
		codeExpirationWarning: "यह कोड <> मिनट में एक्सपायर हो जाएगा.",
		securityText: "अपनी सुरक्षा के लिए, इस कोड को किसी के साथ शेयर न करें.",
		copyCode: "कोड कॉपी करें",
	},
	Hungarian: {
		templateFormat: "*{{1}}* az Ön megerősítő kódja.",
		codeExpirationWarning: "Ez a kód <> percen belül lejár.",
		securityText: "A biztonsága érdekében ne ossza meg ezt a kódot.",
		copyCode: "Kód másolása",
	},
	Indonesian: {
		templateFormat: "*{{1}}* adalah kode verifikasi Anda.",
		codeExpirationWarning: "Kode ini akan kedaluwarsa dalam <> menit.",
		securityText: "Untuk keamanan Anda, jangan bagikan kode ini.",
		copyCode: "Salin kode",
	},
	Irish: {
		templateFormat: "*{{1}}* is é do chód fíoraithe.",
		codeExpirationWarning: "Tá an cód seo ag dul in éag i gceann <> nóiméad.",
		securityText: "Ar mhaithe le do shlándáil, ná roinn an cód seo.",
		copyCode: "Cóipeáil cód",
	},
	Italian: {
		templateFormat: "*{{1}}* è il tuo codice di verifica.",
		codeExpirationWarning: "Questo codice scade tra <> minuto/i.",
		securityText: "Per la tua sicurezza, non condividere questo codice.",
		copyCode: "Copia il codice",
	},
	Japanese: {
		templateFormat: "*{{1}}* はあなたの認証コードです。",
		codeExpirationWarning: "このコードは <> 分後に期限切れになります。",
		securityText:
			"あなたのセキュリティのために、このコードを共有しないでください。",
		copyCode: "コードをコピー",
	},
	Kannada: {
		templateFormat: "*{{1}}* ನಿಮ್ಮ ಪರಿಶೀಲನೆ ಕೋಡ್ ಆಗಿದೆ.",
		codeExpirationWarning: "ಈ ಕೋಡ್ <> ನಿಮಿಷದಲ್ಲಿ ಅವಧಿ ಮುಗಿಯುತ್ತದೆ.",
		securityText: "ನಿಮ್ಮ ಭದ್ರತೆಯ ನಿಮಿತ್ತ, ಈ ಕೋಡ್ ಅನ್ನು ಹಂಚಿಕೊಳ್ಳಬೇಡಿ.",
		copyCode: "ಕೋಡ್ ನಕಲು ಮಾಡು",
	},
	Kazakh: {
		templateFormat: "*{{1}}* сіздің тексеру кодыңыз.",
		codeExpirationWarning: "Бұл код <> минуттан кейін жарамсыз болады.",
		securityText: "Сіздің қауіпсіздігіңіз үшін бұл кодты бөліспеңіз.",
		copyCode: "Кодты көшіру",
	},
	Korean: {
		templateFormat: "*{{1}}* 는 귀하의 인증 코드입니다.",
		codeExpirationWarning: "이 코드는 <>분 후에 만료됩니다.",
		securityText: "귀하의 보안을 위해 이 코드를 공유하지 마십시오.",
		copyCode: "코드 복사",
	},
	Lao: {
		templateFormat: "*{{1}}* ແມ່ນລະຫັດຢືນຢັນຂອງທ່ານ.",
		codeExpirationWarning: "ລະຫັດນີ້ຈະໝົດອາຍຸໃນ <> ນາທີ.",
		securityText: "ເພື່ອຄວາມປອດໄພຂອງທ່ານ, ຢ່າແບ່ງປັນລະຫັດນີ້.",
		copyCode: "ສຳເນົາລະຫັດ",
	},
	Latvian: {
		templateFormat: "*{{1}}* ir jūsu verifikācijas kods.",
		codeExpirationWarning: "Šis kods beidzas pēc <> minūtēm.",
		securityText: "Jūsu drošībai, nedalieties ar šo kodu.",
		copyCode: "Kopēt kodu",
	},
	Lithuanian: {
		templateFormat: "*{{1}}* yra jūsų patvirtinimo kodas.",
		codeExpirationWarning: "Šis kodas baigs galioti per <> minutę.",
		securityText: "Dėl jūsų saugumo neatskleiskite šio kodo.",
		copyCode: "Kopijuoti kodą",
	},
	Macedonian: {
		templateFormat: "*{{1}}* е вашиот код за верификација.",
		codeExpirationWarning: "Овој код истекува за <> минути.",
		securityText: "За ваша безбедност, не го споделувајте овој код.",
		copyCode: "Копирајте го кодот",
	},
	Malay: {
		templateFormat: "*{{1}}* adalah kod pengesahan anda.",
		codeExpirationWarning: "Kod ini akan tamat dalam <> minit.",
		securityText: "Untuk keselamatan anda, jangan kongsi kod ini.",
		copyCode: "Salin kod",
	},
	Malayalam: {
		templateFormat: "*{{1}}* നിങ്ങളുടെ സ്ഥിരീകരണ കോഡ് ആണ്.",
		codeExpirationWarning: "ഈ കോഡ് <> മിനിറ്റിൽ കാലാവധി കഴിയുന്നതാണ്.",
		securityText: "നിങ്ങളുടെ സുരക്ഷയ്‌ക്കായി, ഈ കോഡ് പങ്കിടരുത്.",
		copyCode: "കോഡ് പകർത്തുക",
	},
	Marathi: {
		templateFormat: "*{{1}}* हा तुमचा सत्यापन कोड आहे.",
		codeExpirationWarning: "हा कोड <> मिनिटात समाप्त होईल.",
		securityText: "तुमच्या सुरक्षेसाठी, हा कोड सामायिक करू नका.",
		copyCode: "कोड कॉपी करा",
	},
	Norwegian: {
		templateFormat: "*{{1}}* er din bekreftelseskode.",
		codeExpirationWarning: "Denne koden utløper om <> minutter.",
		securityText: "For din sikkerhet, ikke del denne koden.",
		copyCode: "Kopier kode",
	},
	Persian: {
		templateFormat: "*{{1}}* کد تأیید شما است.",
		codeExpirationWarning: "این کد در <> دقیقه منقضی می‌شود.",
		securityText: "برای امنیت شما، این کد را به اشتراک نگذارید.",
		copyCode: "کپی کد",
	},
	Polish: {
		templateFormat: "*{{1}}* to twój kod weryfikacyjny.",
		codeExpirationWarning: "Ten kod wygaśnie za <> minut.",
		securityText: "Dla twojego bezpieczeństwa nie udostępniaj tego kodu.",
		copyCode: "Skopiuj kod",
	},
	"Portuguese (BR)": {
		templateFormat: "*{{1}}* é o seu código de verificação.",
		codeExpirationWarning: "Este código expira em <> minuto(s).",
		securityText: "Para sua segurança, não compartilhe este código.",
		copyCode: "Copiar código",
	},
	"Portuguese (POR)": {
		templateFormat: "*{{1}}* é o seu código de verificação.",
		codeExpirationWarning: "Este código expira em <> minuto(s).",
		securityText: "Para sua segurança, não compartilhe este código.",
		copyCode: "Copiar código",
	},
	Punjabi: {
		templateFormat: "*{{1}}* ਤੁਹਾਡਾ ਪ੍ਰਮਾਣਕਰਨ ਕੋਡ ਹੈ।",
		codeExpirationWarning: "ਇਹ ਕੋਡ <> ਮਿੰਟ ਵਿੱਚ ਮਿਆਦ ਬੰਦ ਹੋ ਜਾਵੇਗਾ।",
		securityText: "ਤੁਹਾਡੇ ਸੁਰੱਖਿਆ ਲਈ, ਇਸ ਕੋਡ ਨੂੰ ਸਾਂਝਾ ਨਾ ਕਰੋ।",
		copyCode: "ਕੋਡ ਕਾਪੀ ਕਰੋ",
	},
	Romanian: {
		templateFormat: "*{{1}}* este codul dvs. de verificare.",
		codeExpirationWarning: "Acest cod expiră în <> minute.",
		securityText: "Pentru siguranța dvs., nu împărtășiți acest cod.",
		copyCode: "Copiați codul",
	},
	Russian: {
		templateFormat: "*{{1}}* это ваш проверочный код.",
		codeExpirationWarning: "Этот код истекает через <> минуту.",
		securityText: "Для вашей безопасности не сообщайте этот код.",
		copyCode: "Скопировать код",
	},
	Serbian: {
		templateFormat: "*{{1}}* је ваш верификациони код.",
		codeExpirationWarning: "Овај код истиче за <> минут.",
		securityText: "Због ваше безбедности не делите овај код.",
		copyCode: "Копирај код",
	},
	Slovak: {
		templateFormat: "*{{1}}* je váš overovací kód.",
		codeExpirationWarning: "Tento kód vyprší o <> minút.",
		securityText: "Kvôli vašej bezpečnosti tento kód nezdieľajte.",
		copyCode: "Kopírovať kód",
	},
	Slovenian: {
		templateFormat: "*{{1}}* je vaša potrditvena koda.",
		codeExpirationWarning: "Ta koda poteče v <> minutah.",
		securityText: "Zaradi vaše varnosti te kode ne delite.",
		copyCode: "Kopiraj kodo",
	},
	Spanish: {
		templateFormat: "*{{1}}* es su código de verificación.",
		codeExpirationWarning: "Este código caduca en <> minutos.",
		securityText: "Por su seguridad, no comparta este código.",
		copyCode: "Copiar código",
	},
	"Spanish (ARG)": {
		templateFormat: "*{{1}}* es su código de verificación.",
		codeExpirationWarning: "Este código caduca en <> minutos.",
		securityText: "Por su seguridad, no comparta este código.",
		copyCode: "Copiar código",
	},
	"Spanish (SPA)": {
		templateFormat: "*{{1}}* es su código de verificación.",
		codeExpirationWarning: "Este código caduca en <> minutos.",
		securityText: "Por su seguridad, no comparta este código.",
		copyCode: "Copiar código",
	},
	"Spanish (MEX)": {
		templateFormat: "*{{1}}* es su código de verificación.",
		codeExpirationWarning: "Este código caduca en <> minutos.",
		securityText: "Por su seguridad, no comparta este código.",
		copyCode: "Copiar código",
	},
	Swahili: {
		templateFormat: "*{{1}}* ni msimbo wako wa uthibitishaji.",
		codeExpirationWarning: "Msimbo huu utakwisha muda baada ya <> dakika.",
		securityText: "Kwa usalama wako, usishiriki msimbo huu.",
		copyCode: "Nakili msimbo",
	},
	Swedish: {
		templateFormat: "*{{1}}* är din verifieringskod.",
		codeExpirationWarning: "Denna kod upphör att gälla om <> minuter.",
		securityText: "För din säkerhet, dela inte denna kod.",
		copyCode: "Kopiera kod",
	},
	Tamil: {
		templateFormat: "*{{1}}* உங்கள் சரிபார்ப்பு குறியீடு ஆகும்.",
		codeExpirationWarning: "இந்த குறியீடு <> நிமிடங்களில் காலாவதியாகிவிடும்.",
		securityText: "உங்கள் பாதுகாப்பிற்காக, இந்த குறியீட்டை பகிர வேண்டாம்.",
		copyCode: "குறியீட்டை நகலெடுக்கவும்",
	},
	Telugu: {
		templateFormat: "*{{1}}* మీ ధృవీకరణ కోడ్.",
		codeExpirationWarning: "ఈ కోడ్ <> నిమిషాల్లో గడువు ముగుస్తుంది.",
		securityText: "మీ భద్రత కోసం, ఈ కోడ్‌ను పంచుకోవద్దు.",
		copyCode: "కోడ్‌ను కాపీ చేయండి",
	},
	Thai: {
		templateFormat: "*{{1}}* เป็นรหัสยืนยันของคุณ.",
		codeExpirationWarning: "รหัสนี้จะหมดอายุใน <> นาที.",
		securityText: "เพื่อความปลอดภัยของคุณ อย่าแบ่งปันรหัสนี้.",
		copyCode: "คัดลอกรหัส",
	},
	Turkish: {
		templateFormat: "*{{1}}* sizin doğrulama kodunuz.",
		codeExpirationWarning: "Bu kod <> dakika içinde sona erecektir.",
		securityText: "Güvenliğiniz için bu kodu paylaşmayın.",
		copyCode: "Kodu kopyala",
	},
	Ukrainian: {
		templateFormat: "*{{1}}* є вашим кодом підтвердження.",
		codeExpirationWarning: "Цей код закінчується через <> хвилину.",
		securityText: "Для вашої безпеки не повідомляйте цей код.",
		copyCode: "Скопіювати код",
	},
	Urdu: {
		templateFormat: "*{{1}}* آپ کا تصدیقی کوڈ ہے۔",
		codeExpirationWarning: "یہ کوڈ <> منٹ میں ختم ہوجائے گا۔",
		securityText: "آپ کی سیکیورٹی کے لیے، اس کوڈ کو شیئر نہ کریں۔",
		copyCode: "کوڈ کاپی کریں",
	},
	Uzbek: {
		templateFormat: "*{{1}}* bu sizning tasdiqlash kodingiz.",
		codeExpirationWarning: "Ushbu kod <> daqiqadan keyin muddati tugaydi.",
		securityText: "Xavfsizligingiz uchun ushbu kodni baham ko'rmang.",
		copyCode: "Kodini nusxalash",
	},
	Vietnamese: {
		templateFormat: "*{{1}}* là mã xác minh của bạn.",
		codeExpirationWarning: "Mã này sẽ hết hạn sau <> phút.",
		securityText: "Vì sự an toàn của bạn, không chia sẻ mã này.",
		copyCode: "Sao chép mã",
	},
	Zulu: {
		templateFormat: "*{{1}}* yi ikhodi yakho yokuqinisekisa.",
		codeExpirationWarning: "Le khodi izophela ngemizuzu engu-<>.",
		securityText: "Ngokuphepha kwakho, ungayihlanganyeli le khodi.",
		copyCode: "Kopisha ikhodi",
	},
};


export default OPTIONS